import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Heart } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vets-intake-demo/artifacts/e4mtecfo_Untitled%20design%20%2892%29.png";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/intake', label: 'Get Started' },
    { path: '/shop', label: 'Shop' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white sticky top-0 z-50 border-b border-gray-100" data-testid="main-navigation" role="navigation" aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center -my-4" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Worthy Vets Service Group" 
              className="h-28 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`text-base font-semibold transition-colors ${
                  isActive(link.path)
                    ? 'text-wv-red'
                    : 'text-wv-blue hover:text-wv-red'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Buttons - Desktop */}
          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/donate"
              className="inline-flex items-center gap-2 bg-wv-red text-white font-bold text-base py-3 px-5 rounded-md hover:bg-red-700 transition-colors"
              data-testid="nav-donate-button"
            >
              <Heart className="w-4 h-4" />
              Donate
            </Link>
            <Link
              to="/intake"
              className="bg-wv-blue text-white font-bold text-base py-3 px-6 rounded-md hover:bg-blue-800 transition-colors"
              data-testid="nav-cta-button"
            >
              Request Assistance
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-wv-blue p-2"
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200" data-testid="mobile-menu">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`block text-xl font-semibold py-3 border-b border-gray-100 ${
                  isActive(link.path)
                    ? 'text-wv-red'
                    : 'text-wv-blue'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/donate"
              onClick={() => setIsOpen(false)}
              className="inline-flex items-center justify-center gap-2 bg-wv-red text-white font-bold block text-center py-4 rounded-md mt-4"
              data-testid="mobile-donate-button"
            >
              <Heart className="w-5 h-5" />
              Support a Veteran
            </Link>
            <Link
              to="/intake"
              onClick={() => setIsOpen(false)}
              className="bg-wv-red text-white font-bold block text-center py-4 rounded-md mt-2"
              data-testid="mobile-cta-button"
            >
              Request Assistance
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};
